import { BaseAndCrudRoutes } from '@monorepo/tools/src/lib/routes/base.routes';

export class ReportsRoutes extends BaseAndCrudRoutes {
	constructor() {
		super('statistics');
	}
}
